<template>
  <div>
    <div class="searchType">
      <!-- <span :class="['typeLabel',{mobileFontSize:$isMobile}]">搜索类型：</span>
      <el-select v-model="type" placeholder="请选择">
        <el-option v-for="(item,i) in types" :key="i" :label="item" :value="item">
        </el-option>
      </el-select> -->
      <el-input v-model="searchKey" size='mini'  placeholder="请输入中文名或化学文摘号"  @input="findAllTouchLimit" clearable>
        <i class="el-icon-search" type="primary" @click="findAllTouchLimit" slot='suffix' ></i>
      </el-input>
      &nbsp;&nbsp;
      <el-button size="mini" plain="" type="primary" @click='review'>预览并导出</el-button>
    </div>
    <div>
      <el-radio-group v-model="initial" size="mini">
        <el-radio-button label="全部"></el-radio-button>
        <el-radio-button v-for="(item,i) in pinyin" :disabled="initialArr.indexOf(item)!=-1?false:true" :label="item"
          :key="i">{{item}}</el-radio-button>
      </el-radio-group>
    </div>

    <!-- PC端 -->
    <el-table size='mini' :row-key="getRowKey" @selection-change="handleSelectionChange" v-show="!$isMobile" :data="touchLimits"
      style="width: 100%">
      <el-table-column :reserve-selection='true' type="selection" width="55">
      </el-table-column>
      <el-table-column prop="showName" align='center' label="中文名">
      </el-table-column>
      <el-table-column label="别名" align='center' prop="chineseName">
        <template slot-scope='scope'>
          <span v-html="scope.row.chineseName?scope.row.chineseName.join('、'):'-'"></span>
        </template>
      </el-table-column>
      <el-table-column prop="englishName" align='center' label="英文名">
      </el-table-column>
      <el-table-column align='center' :label="chemistryLabel">
        <template slot-scope='scope'>
          <p>{{scope.row.casNum?scope.row.casNum:'-'}}</p>
        </template>
      </el-table-column>
      <el-table-column label="OELs mg/m3" align='center'>
        <template slot="header">
          <span>OELs (mg/m</span>
          <sup>3</sup>
          <span>)</span>
        </template>
        <el-table-column label="MAC" align='center' width="70%">
          <template slot-scope="scope">
            <div v-show="scope.row.MAC==0">-</div>
            <div v-show="scope.row.MAC!=0">
              <p v-if="touchLimitUrl!=undefined">
                <span>{{scope.row.MAC.substring(0,scope.row.MAC.length-1)}}</span>
                <sup>{{scope.row.MAC.substring(scope.row.MAC.length-1)}}</sup>
              </p>
              <p v-if="touchLimitUrl==undefined">{{scope.row.MAC}}</p>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="PC-TWA" align='center' width="70%">
          <template slot-scope="scope">
              <p v-if="touchLimitUrl!=undefined">
                <span>{{scope.row.PC_TWA.substring(0,scope.row.PC_TWA.length-1)}}</span>
                <sup>{{scope.row.PC_TWA.substring(scope.row.PC_TWA.length-1)}}</sup>
              </p>
              <p v-if="touchLimitUrl==undefined">{{scope.row.PC_TWA}}</p>
          </template>
        </el-table-column>
        <el-table-column label="PC-STEL " align='center' width="70%">
          <template slot-scope="scope">
              <p v-if="touchLimitUrl!=undefined">
                <span>{{scope.row.PC_STEL.substring(0,scope.row.PC_STEL.length-1)}}</span>
                <sup>{{scope.row.PC_STEL.substring(scope.row.PC_STEL.length-1)}}</sup>
              </p>
              <p v-if="touchLimitUrl == undefined">{{scope.row.PC_STEL}}</p>
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column prop="healthEffect" label="临界不良健康效应" align='center'>
        <template slot-scope='scope'>
          <p>{{scope.row.healthEffect?scope.row.healthEffect:'-'}}</p>
        </template>
      </el-table-column>
       <el-table-column prop="samplingMedium" label="采样介质" align='center'>
          <template slot-scope="scope">
            {{scope.row.samplingMedium || '-'}}
          </template>
      </el-table-column>
       <el-table-column label="采样方式" align='center'>
        <el-table-column label="定点" align='center'>
          <template slot-scope="scope">
            <p>{{scope.row.fixedPointDetection?`${scope.row.fixedPointDetection.flow}${scope.row.fixedPointDetection.instrument}${scope.row.fixedPointDetection.samplingTime|| '-'}`:'-'}}</p>
          </template>
        </el-table-column>
        <el-table-column label="个体" align='center'>
          <template slot-scope="scope">
            <p>{{scope.row.individualDetection ?`${scope.row.individualDetection.flow}${scope.row.individualDetection.instrument}${scope.row.individualDetection.samplingTime|| '-'}`:'-'}}</p>
          </template>
        </el-table-column>
       </el-table-column>
      <el-table-column prop="standard" label="采样依据" align='center' width="180%">
        <template slot-scope="scope">
            {{scope.row.standard || '-'}}
          </template>
      </el-table-column>
      <el-table-column prop="note" label="备注" align='center'>
        <template slot-scope='scope'>
          <p>{{scope.row.note?scope.row.note:'-'}}</p>
        </template>
      </el-table-column>
    </el-table>

    <!-- 移动端 -->
    <el-table size='mini' :row-key="getRowKey" @selection-change="handleSelectionChange" class="mobileTable" v-show="$isMobile" :data="touchLimits" style="width: 100%">
      <el-table-column :reserve-selection='true' type="selection" width="55">
      </el-table-column>
      <el-table-column type="expand">
        <template slot-scope="scope">
          <el-form label-position="left" class="demo-table-expand">
            <el-form-item label="采样介质">
              <span>{{scope.row.samplingMedium || '-'}}</span>
            </el-form-item>
            <el-form-item label="定点">
                <p>{{scope.row.fixedPointDetection?`${scope.row.fixedPointDetection.flow}${scope.row.fixedPointDetection.instrument}${scope.row.fixedPointDetection.samplingTime|| '-'}`:'-'}}</p>
            </el-form-item>
            <el-form-item label="个体">
                <p>{{scope.row.individualDetection ?`${scope.row.individualDetection.flow}${scope.row.individualDetection.instrument}${scope.row.individualDetection.samplingTime|| '-'}`:'-'}}</p>
            </el-form-item>
          <el-form-item label="采样依据">
                {{scope.row.standard || '-'}}
          </el-form-item>
          </el-form>
        </template>

      </el-table-column>
      <el-table-column
          label="中文名"
          prop="showName"
          >
        </el-table-column>
        <el-table-column
          label="别名"
          prop="chineseName"
          >
          <template slot-scope='scope'>
          <span v-html="scope.row.chineseName?scope.row.chineseName.join('、'):'-'"></span>
        </template>
      </el-table-column>
      <el-table-column label="化学文摘号" prop="casNum">
        <template slot-scope='scope'>
          <p>{{scope.row.casNum?scope.row.casNum:'-'}}</p>
        </template>
      </el-table-column>
      <el-table-column label="OELs mg/m3" align='center'>
        <template slot="header">
          <span>OELs (mg/m</span>
          <sup>3</sup>
          <span>)</span>
        </template>
        <el-table-column label="MAC" align='center' width="70%">
          <template slot-scope="scope">
            <div v-show="scope.row.MAC==0">-</div>
            <div v-show="scope.row.MAC!=0">
              <p v-if="touchLimitUrl!=undefined">
                <span>{{scope.row.MAC.substring(0,scope.row.MAC.length-1)}}</span>
                <sup>{{scope.row.MAC.substring(scope.row.MAC.length-1)}}</sup>
              </p>
              <p v-if="touchLimitUrl==undefined">{{scope.row.MAC}}</p>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="PC-TWA" align='center' width="70%">
          <template slot-scope="scope">
              <p v-if="touchLimitUrl!=undefined">
                <span>{{scope.row.PC_TWA.substring(0,scope.row.PC_TWA.length-1)}}</span>
                <sup>{{scope.row.PC_TWA.substring(scope.row.PC_TWA.length-1)}}</sup>
              </p>
              <p v-if="touchLimitUrl==undefined">{{scope.row.PC_TWA}}</p>
          </template>
        </el-table-column>
        <el-table-column label="PC-STEL " align='center' width="70%">
          <template slot-scope="scope">
              <p v-if="touchLimitUrl!=undefined">
                <span>{{scope.row.PC_STEL.substring(0,scope.row.PC_STEL.length-1)}}</span>
                <sup>{{scope.row.PC_STEL.substring(scope.row.PC_STEL.length-1)}}</sup>
              </p>
              <p v-if="touchLimitUrl == undefined">{{scope.row.PC_STEL}}</p>
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column label="临界不良效应">
        <template slot-scope="scope">
          <p style="margin-left: 10px">{{scope.row.healthEffect?scope.row.healthEffect:'-'}}</p>
        </template>
      </el-table-column>
      <el-table-column prop="samplingMedium" label="采样介质" align='center'>
          <template slot-scope="scope">
            {{scope.row.samplingMedium || '-'}}
          </template>
      </el-table-column>
      <el-table-column prop="note" label="备注" align='center'>
        <template slot-scope='scope'>
          <div>{{scope.row.note?scope.row.note:'-'}}</div>
        </template>
      </el-table-column>
    </el-table>
    <div class="block">
      <el-pagination :class="{mobilePage:$isMobile}" background="" layout="prev, pager, next" :page-size='10' :total='totalLength'
        :current-page='currentPage' @current-change='currentchange' ref='pagination'>
      </el-pagination>
    </div>
    <!-- 预览导出对话框 -->
    <el-dialog :width='$isMobile?"80%":"50%"' title="预览并导出excel" :visible.sync="dialogFormVisible">
      <el-tag @close="closeTag(i)" closable v-for="(item,i) in multipleSelection" :key='i'>{{item.chineseName}}</el-tag>
      <div slot="footer" class="dialog-footer">
        <el-button :size="$isMobile?'mini':'medium'" @click="dialogFormVisible = false">取 消</el-button>
        <json-excel :footer='$route.name=="chemistryTouchLimit"?footer:""' type='xls' class="json2excel" :fields='json_fields' :data='multipleSelection' :title='$route.name=="biologicalTouchLimit"?"工作场所生物有害因素职业接触限值":"工作场所化学有害因素职业接触限值"'
          :name='$route.name=="biologicalTouchLimit"?"工作场所生物有害因素职业接触限值":"工作场所化学有害因素职业接触限值"'>
          <el-button  :size="$isMobile?'mini':'medium'" type="primary" @click="dialogFormVisible = false">确 定</el-button>
        </json-excel>
      </div>
    </el-dialog>
  </div>

</template>

<script>
  import JsonExcel from 'vue-json-excel'
  export default {
    data() {
      return {
        footer:'注：TEQ：Toxic Equivalent Quantity，国际毒性当量。由于环境中的二噁英类物质主要以混合物的形式存在，在对二噁英类进行评价时，通常将各同类物折算成相当于2,3,7,8-TCDD 的量来表示，称为毒性当量。',
        excelName:'工作场所化学有害因素职业接触限值',
        dialogFormVisible:false,
        json_fields:{
          "序号":"index",
          "化学因素中文名称":'chineseName',
          "MAC":'OELs.MAC',
          'PC-TWA':'OELs.PC_TWA',
          'PC-STEL':'OELs.PC_STEL',
          '备注':'note'
        },
        //获取row的key值
        getRowKey(row) {
          return row._id
        },
        multipleSelection: [], //多选数组
        touchLimitUrlData: '',
        pinyin: ["A", "B", "C", "D", "E", "F", "G", "H", "J", "K", "L", "M", "N", "P", "Q", "R", "S", "T", "W", "X",
          "Y", "Z"
        ],
        displayInitalArr: [],
        initial: '全部', //首字母
        initialArr: [], //所有数据的首字母集合
        types: ['中文名', '化学文摘号'],
        type: '中文名',
        totalLength: 0, //数据总长度
        currentPage: 1,
        touchLimits: [],
        searchKey: '',
        input:"",
        chemistryLabel: `化学文摘号
CAS号`

      }

    },
    props: {
      initialUrl: {
        type: String
      },
      touchLimitUrl: {
        type: String
      }
    },
    watch: {
      initial(newval) { //监听选择的首字母
        this.currentPage = 1
        this.findAllTouchLimit()
      },
      searchKey(newval) { //监听搜索框文本
        if (!newval) {
          this.findAllTouchLimit()
        }
      }
    },
    created() {
      this.touchLimitUrlData = this.touchLimitUrl
      //按回车键触发
      document.onkeydown = e => {
        let key = window.event.keyCode
        if (key === 13) {
          this.findAllTouchLimit()
        }
      }
      this.findInitialList()
      this.findAllTouchLimit()
    },
    components:{
      JsonExcel
    },
    methods: {
      review(){
        this.dialogFormVisible = true
        if(this.multipleSelection.length === 0){
          this.dialogFormVisible = false
          this.message({
                    message: '您暂未选择',
                    type: 'warning'
                  });
        }
      },
      closeTag(i){
        this.multipleSelection.splice(i,1)
      },
      //复选框
      handleSelectionChange(val) {
        val.map((item,i)=>{
          item.index = i+1
        })
        this.multipleSelection = val
      },
      currentchange() {
        this.currentPage = this.$refs.pagination.internalCurrentPage
        this.findAllTouchLimit()
      },
      //获取开头首字母集合
      async findInitialList() {
        let initialUrl = this.initialUrl ? this.initialUrl : this.$serviceAPI.findInitialList
        let res = await this.$axios.get(initialUrl)
        this.initialArr = res.data.data.map(item => item.initial)
      },
      //查询
      async findAllTouchLimit() {
        // let params = {
        //   pageNum: this.currentPage
        // }
        if (this.searchKey != '') {
          this.currentPage = 1
        }
        // if (this.type === '中文名') {
        //   params = {
        //     casNum: '',
        //     chineseName: this.searchKey,
        //     pageNum: this.currentPage,
        //     initial: this.initial
        //   }
        // } else {
        //   params = {
        //     casNum: this.searchKey,
        //     chineseName: '',
        //     pageNum: this.currentPage,
        //     initial: this.initial
        //   }
        // }
        let initial = this.initial
        if(initial === '全部'){
          initial = ""
        } 
        let params = {
            pageNum: this.currentPage,
            initial,
            searchkey: this.searchKey
          }
          console.log(params)
        let touchLimitUrl = this.touchLimitUrl ? this.touchLimitUrl : this.$serviceAPI.findAllTouchLimit

        let res = await this.$axios.post(touchLimitUrl, params)
        // orderByFirstPin(res.data.data.data, 'chineseName')
        this.touchLimits = res.data.data.data
        this.totalLength = res.data.data.totalLength
      },
    }
  }
</script>

<style scoped="scoped">
@import url("../../assets/iconfont.css");

</style>



// WEBPACK FOOTER //
// src/components/subPage/chemistryTouchLimit.vue